import React from 'react';
import styles from './CustomButton.module.scss';

type CustomButtonProps = {
  content: React.ReactNode;
  styleType: 'active' | 'default';
  onClick?: React.MouseEventHandler<HTMLButtonElement>;
  type?: 'button' | 'submit' | 'reset';
};

const CustomButton = ({
  content,
  styleType,
  onClick,
  type = 'button',
}: CustomButtonProps) => {
  return styleType === 'active' ? (
    <button type={type} className={`${styles.active} ${styles.normal}`} onClick={onClick}>
      {content}
    </button>
  ) : (
    <button type={type} className={styles.normal} onClick={onClick}>
      {content}
    </button>
  );
};

export default CustomButton;
